import type { ReactNode } from 'react'

import type { SearchModalItemKind } from '../../types/modalItemKind.type'
import { SearchRowIcon } from '../SearchRowIcon'

import styles from '../../SearchModal.module.scss'

type SearchRowIconCellProps = {
  rowIconKind: string
  icon?: ReactNode
  kind?: SearchModalItemKind
}

export function SearchRowIconCell({ rowIconKind, icon, kind }: SearchRowIconCellProps) {
  return (
    <span className={styles.iconCell} data-row-icon-cell={rowIconKind}>
      {icon ?? <SearchRowIcon kind={kind} />}
    </span>
  )
}
